export default "__VITE_ASSET__CGIT_Ykr__"